import React, { useEffect, useState } from "react";

const TARGET = new Date("2028-07-21T00:00:00").getTime();

function compute() {
  const now = Date.now();
  const diff = TARGET - now;
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, over: true };
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { days, hours, minutes, seconds, over: false };
}

const Cell = ({ value, label }) => (
  <div className="flex flex-col items-center min-w-[64px] md:min-w-[80px]">
    <div
      className="font-serif text-3xl md:text-5xl text-[#1a2947] tabular-nums tracking-tight"
      data-testid={`countdown-${label}`}
    >
      {String(value).padStart(2, "0")}
    </div>
    <div className="text-[10px] md:text-xs tracking-[0.16em] uppercase text-stone-500 mt-1">
      {label}
    </div>
  </div>
);

export default function CountdownClock() {
  const [t, setT] = useState(compute);
  useEffect(() => {
    const id = setInterval(() => setT(compute()), 1000);
    return () => clearInterval(id);
  }, []);

  if (t.over) {
    return (
      <div
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#1a2947] text-white font-semibold px-5 py-2.5"
        data-testid="countdown-clock"
      >
        We're together — the reunion is here.
      </div>
    );
  }

  // Milestone tiers
  const isFinalWeek = t.days < 7;
  const isFinalMonth = t.days < 30 && !isFinalWeek;

  let cardClass =
    "mt-8 inline-flex flex-col gap-2 rounded-2xl bg-white/90 backdrop-blur border border-[#e6e2d6] px-4 py-4 md:px-6 md:py-5 shadow-[0_4px_20px_-4px_rgba(44,42,38,0.08)]";
  let labelClass = "label-eyebrow text-[#8a7a3a]";
  let labelText = "Denver · July 21, 2028";
  let tease = null;

  if (isFinalMonth) {
    cardClass =
      "mt-8 inline-flex flex-col gap-2 rounded-2xl bg-[#fff8e1] border-2 border-[#e7c96b] px-4 py-4 md:px-6 md:py-5 shadow-[0_8px_30px_-8px_rgba(215,180,60,0.45)]";
    labelClass = "label-eyebrow text-[#8a6f1c]";
    tease = (
      <div
        className="text-sm font-semibold text-[#6b5417] mt-2"
        data-testid="countdown-tease"
      >
        🎒 Start packing!
      </div>
    );
  }

  if (isFinalWeek) {
    cardClass =
      "mt-8 inline-flex flex-col gap-2 rounded-2xl bg-gradient-to-br from-[#fff2c2] to-[#f6dc85] border-2 border-[#d4a935] px-4 py-4 md:px-6 md:py-5 shadow-[0_12px_36px_-8px_rgba(215,180,60,0.6)] animate-pulse-slow";
    labelClass = "label-eyebrow text-[#6b5417]";
    labelText = "Almost there · Denver 2028";
    tease = (
      <div
        className="text-sm font-semibold text-[#5a4310] mt-2"
        data-testid="countdown-tease"
      >
        ✈️ See you in Denver!
      </div>
    );
  }

  return (
    <div className={cardClass} data-testid="countdown-clock">
      <div className={labelClass}>{labelText}</div>
      <div className="flex items-end gap-3 md:gap-5 divide-x divide-[#eae5d9]">
        <Cell value={t.days} label="days" />
        <div className="pl-3 md:pl-5"><Cell value={t.hours} label="hours" /></div>
        <div className="pl-3 md:pl-5"><Cell value={t.minutes} label="minutes" /></div>
        <div className="pl-3 md:pl-5"><Cell value={t.seconds} label="seconds" /></div>
      </div>
      {tease}
    </div>
  );
}
